import React from "react"
import type { CustomFieldDate } from "@love-irish/types"
import { Badge } from "@love-irish/ui-components"
const DateField = ({ field }: { field: CustomFieldDate }) => {
  const displayValue = field.value
    ? new Date(field.value).toLocaleDateString()
    : null

  return (
    <Badge variant="outline">
      <strong className="mr-1">{field.label}:</strong> {displayValue}
    </Badge>
  )
}

export default DateField
